import cx from 'classnames';
import { FunctionComponent, ReactNode } from 'react';

import classes from './tooltip.module.css';

const Tooltip: FunctionComponent<{
  as?: keyof JSX.IntrinsicElements;
  children: ReactNode;
  mainWidth?: string;
  className?: any;
}> = ({ as: As = 'div', children, mainWidth, className, ...props }) => {
  return (
    <As
      className={cx(
        classes.mainModalBox,
        props,
        'p-4 bg-neutral-80 !z-[9999]',
        mainWidth ? mainWidth : 'w-[328px]',
        className
      )}
    >
      {children}
    </As>
  );
};

export default Tooltip;
